<h2 class="text-center">{{ title }}</h2>
<ng-container>
  <p>{{ description }}</p>

  <fgbcl-errors></fgbcl-errors>

  <div *ngIf="accountsList && accountsList.length > 1" class="table-container mb-2">
    <div
      class="row my-3 mx-1 mx-lg-0 py-3 rounded shadow account-card text-left"
      *ngFor="let account of accountsList"
      [ngClass]="{ selected: externalRef === account.ExternalRefNumber }"
    >
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6 col-7">
            <label>Name</label>
            <div class="info-field">{{ account.FirstName }} {{ account.LastName }}</div>
          </div>
          <div class="col-lg-6 col-5 text-center">
            <label>Account #</label>
            <div class="info-field">{{ account.ExternalRefNumber }}</div>
          </div>
          <div class="col-12 mt-2">
            <label>Email Address</label>
            <div class="info-field">{{ account.EmailAddress }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="row">
          <div class="col-lg-12 col-6">
            <label>Status</label>
            <ng-container [ngSwitch]="account.Status">
              <div class="info-field">
                <div *ngSwitchCase="0" class="text-danger">Not Connected</div>
                <div *ngSwitchCase="1" class="text-success">Connected</div>
                <div *ngSwitchCase="2" class="text-danger">Not Connected</div>
                <div *ngSwitchDefault class="text-danger">Already In Use</div>
              </div>
            </ng-container>
          </div>
          <div class="col-lg-12 col-6 mt-2 text-center">
            <div>
              <ng-container [ngSwitch]="account.Status">
                <div *ngSwitchCase="0">
                  <button (click)="submitStep(account.ExternalRefNumber)" class="btn btn-secondary info-field">
                    Create Account
                  </button>
                </div>
                <div *ngSwitchCase="1">
                  <button class="btn btn-primary info-field">
                    <a class="text-on-danger" [href]="account.RedirectUrl"> Log In </a>
                  </button>
                </div>
                <div *ngSwitchCase="2">
                  <button (click)="submitStep(account.ExternalRefNumber)" class="btn btn-secondary info-field">
                    Create Account
                  </button>
                </div>
                <div *ngSwitchDefault>Already In Use</div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-container>
